import * as React from 'react';
import RcCollapse from '../../ext/collapse/index';
import classNames from 'classnames';
import animation from '../_util/openAnimation';
import CollapsePanel from './CollapsePanel';
export default class Collapse extends React.Component {
    render() {
        const { prefixCls, className = '', bordered } = this.props;
        const collapseClassName = classNames({
            [`${prefixCls}_borderless`]: !bordered,
        }, className);
        return <RcCollapse {...this.props} className={collapseClassName}/>;
    }
}
Collapse.Panel = CollapsePanel;
Collapse.defaultProps = {
    prefixCls: 'ui-collapse',
    bordered: true,
    openAnimation: Object.assign({}, animation, { appear() { } }),
};



// WEBPACK FOOTER //
// ./components/collapse/Collapse.tsx